"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPlutusDataCbor = exports.createAuxiliaryDataCbor = exports.getMaximumTokenSets = exports.getAddressFromBech32 = exports.decodeBech32 = exports.getAddressFromHex = exports.calculateMinUtxoAmount = void 0;
const buffer_1 = require("buffer");
const cbors = __importStar(require("@stricahq/cbors"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const _ = require("lodash");
const bs58_1 = __importDefault(require("bs58"));
const bech32_1 = require("bech32");
const constants_1 = require("../constants");
const BaseAddress_1 = __importDefault(require("../address/BaseAddress"));
const ByronAddress_1 = __importDefault(require("../address/ByronAddress"));
const EnterpriseAddress_1 = __importDefault(require("../address/EnterpriseAddress"));
const PointerAddress_1 = __importDefault(require("../address/PointerAddress"));
const helpers_1 = require("./helpers");
const types_1 = require("../types");
const RewardAddress_1 = __importDefault(require("../address/RewardAddress"));
const encoder_1 = require("./encoder");
const calculateMinUtxoAmount = (tokens, lovelacePerUtxoWord, hasPlutusDataHash) => {
    const uniqueTokens = (0, helpers_1.getUniqueTokens)(tokens);
    const roundupBytesToWords = (x) => Math.floor((x + 7) / 8);
    const coinSize = 2;
    let utxoEntrySizeWithoutVal = 27;
    if (hasPlutusDataHash) {
        utxoEntrySizeWithoutVal += 10;
    }
    const adaOnlyUtxoSize = utxoEntrySizeWithoutVal + coinSize;
    const tokenBundle = _(uniqueTokens)
        .groupBy(({ policyId }) => policyId)
        .value();
    const uniqueAssetNames = uniqueTokens.reduce((result, token) => {
        result[token.assetName] = true;
        return result;
    }, {});
    const policyCount = _.reduce(tokenBundle, (result) => {
        result += 1;
        return result;
    }, 0);
    const assetNameSize = _.reduce(uniqueAssetNames, (sum, status, assetName) => sum + Math.max(buffer_1.Buffer.from(assetName, "hex").length, 1), 0);
    const policyIdSize = 28;
    const size = 6 + roundupBytesToWords(uniqueTokens.length * 12 + assetNameSize + policyCount * policyIdSize);
    const minUtxo = lovelacePerUtxoWord.toNumber() * adaOnlyUtxoSize;
    if (uniqueTokens.length === 0) {
        return new bignumber_js_1.default(minUtxo);
    }
    const minUtxoWithTokens = lovelacePerUtxoWord.toNumber() * (utxoEntrySizeWithoutVal + size);
    return bignumber_js_1.default.max(minUtxo, minUtxoWithTokens);
};
exports.calculateMinUtxoAmount = calculateMinUtxoAmount;
const getAddressFromHex = (hexAddress) => {
    const typeHex = hexAddress.toLowerCase().charAt(0);
    const networkId = Number(hexAddress.toLowerCase().charAt(1));
    let stakeCredential;
    let paymentCredential;
    switch (typeHex) {
        case "e":
            stakeCredential = {
                hash: hexAddress.slice(2).slice(0, 56),
                type: types_1.HashType.ADDRESS,
            };
            return new RewardAddress_1.default(networkId, stakeCredential);
        case "f":
            stakeCredential = {
                hash: hexAddress.slice(2).slice(0, 56),
                type: types_1.HashType.SCRIPT,
            };
            return new RewardAddress_1.default(networkId, stakeCredential);
        case "7": {
            paymentCredential = {
                hash: hexAddress.slice(2),
                type: types_1.HashType.SCRIPT,
            };
            return new EnterpriseAddress_1.default(networkId, paymentCredential);
        }
        case "6": {
            paymentCredential = {
                hash: hexAddress.slice(2),
                type: types_1.HashType.ADDRESS,
            };
            return new EnterpriseAddress_1.default(networkId, paymentCredential);
        }
        case "5": {
            paymentCredential = {
                hash: hexAddress.slice(2).slice(0, 56),
                type: types_1.HashType.SCRIPT,
            };
            const vlq = hexAddress.slice(2).slice(56);
            return new PointerAddress_1.default(networkId, paymentCredential, vlq);
        }
        case "4": {
            paymentCredential = {
                hash: hexAddress.slice(2).slice(0, 56),
                type: types_1.HashType.ADDRESS,
            };
            const vlq = hexAddress.slice(2).slice(56);
            return new PointerAddress_1.default(networkId, paymentCredential, vlq);
        }
        case "3":
            paymentCredential = {
                hash: hexAddress.slice(2).slice(0, 56),
                type: types_1.HashType.SCRIPT,
            };
            stakeCredential = {
                hash: hexAddress.slice(2).slice(56),
                type: types_1.HashType.SCRIPT,
            };
            return new BaseAddress_1.default(networkId, paymentCredential, stakeCredential);
        case "2":
            paymentCredential = {
                hash: hexAddress.slice(2).slice(0, 56),
                type: types_1.HashType.ADDRESS,
            };
            stakeCredential = {
                hash: hexAddress.slice(2).slice(56),
                type: types_1.HashType.SCRIPT,
            };
            return new BaseAddress_1.default(networkId, paymentCredential, stakeCredential);
        case "1":
            paymentCredential = {
                hash: hexAddress.slice(2).slice(0, 56),
                type: types_1.HashType.SCRIPT,
            };
            stakeCredential = {
                hash: hexAddress.slice(2).slice(56),
                type: types_1.HashType.ADDRESS,
            };
            return new BaseAddress_1.default(networkId, paymentCredential, stakeCredential);
        case "0":
            paymentCredential = {
                hash: hexAddress.slice(2).slice(0, 56),
                type: types_1.HashType.ADDRESS,
            };
            stakeCredential = {
                hash: hexAddress.slice(2).slice(56),
                type: types_1.HashType.ADDRESS,
            };
            return new BaseAddress_1.default(networkId, paymentCredential, stakeCredential);
        case "8":
            return new ByronAddress_1.default(buffer_1.Buffer.from(hexAddress, "hex"));
        default:
            throw new Error("Unsupported address type");
    }
};
exports.getAddressFromHex = getAddressFromHex;
const decodeBech32 = (bech32Address) => {
    const decoded = bech32_1.bech32.decode(bech32Address, 114);
    const decodedBech = bech32_1.bech32.fromWords(decoded.words);
    const decodedAddress = buffer_1.Buffer.from(decodedBech).toString("hex");
    return {
        prefix: decoded.prefix,
        value: decodedAddress,
    };
};
exports.decodeBech32 = decodeBech32;
const getAddressFromBech32 = (bech32Address) => {
    try {
        const byronAddress = buffer_1.Buffer.from(bs58_1.default.decode(bech32Address));
        try {
            cbors.Decoder.decode(byronAddress);
        }
        catch (e) {
            throw new Error("Invalid Byron Address");
        }
        return new ByronAddress_1.default(byronAddress);
    }
    catch (error) {
        try {
            const decodeAddr = (0, exports.decodeBech32)(bech32Address);
            if (decodeAddr.prefix === "addr" || decodeAddr.prefix === "addr_test") {
                return (0, exports.getAddressFromHex)(decodeAddr.value);
            }
            throw new Error("Invalid Address");
        }
        catch (err) {
            throw new Error("Invalid Address");
        }
    }
};
exports.getAddressFromBech32 = getAddressFromBech32;
const getMaximumTokenSets = (oTokens) => {
    const tokens = _.cloneDeep(oTokens);
    const result = [];
    while (tokens.length > 0) {
        const tokenArray = [];
        const tokenLengthFixed = tokens.length;
        for (let i = 0; i < tokenLengthFixed; i += 1) {
            const token = tokens.pop();
            if (token.amount.lte(constants_1.maxTokenAmount)) {
                tokenArray.push(token);
            }
            else {
                tokenArray.push({
                    assetName: token.assetName,
                    policyId: token.policyId,
                    amount: new bignumber_js_1.default(constants_1.maxTokenAmount),
                });
                token.amount = token.amount.minus(constants_1.maxTokenAmount);
                tokens.push(token);
            }
        }
        result.push(tokenArray);
    }
    return result;
};
exports.getMaximumTokenSets = getMaximumTokenSets;
const createAuxiliaryDataCbor = (auxiliaryData) => {
    const encodedAuxData = (0, encoder_1.encodeAuxiliaryData)(auxiliaryData);
    return cbors.Encoder.encode(encodedAuxData);
};
exports.createAuxiliaryDataCbor = createAuxiliaryDataCbor;
const createPlutusDataCbor = (plutusData) => {
    const encodedPlutusData = (0, encoder_1.encodePlutusData)(plutusData);
    return cbors.Encoder.encode(encodedPlutusData);
};
exports.createPlutusDataCbor = createPlutusDataCbor;
